export default __webpack_public_path__ + "static/media/bizedgeRound.c5e97ad1.svg";